// pages/ForgotPasswordPage.tsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/axiosInstance";
import { API_ENDPOINTS } from "../constants/apiEndpoints";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post(API_ENDPOINTS.AUTH.PASSWORD_RESET, { email });
      setSubmitted(true);
    } catch (err: any) {
      const data = err?.response?.data;
      setError(data?.email?.[0] || data?.detail || "요청에 실패했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-teal-50 px-4">
      <div className="w-full max-w-sm bg-white rounded-3xl shadow-xl p-8">
        <div className="mb-6 text-center">
          <h1 className="text-xl font-bold text-slate-900">비밀번호 재설정</h1>
          <p className="mt-1 text-sm text-slate-500">가입 시 등록한 이메일로 재설정 링크를 보내드립니다.</p>
        </div>

        {submitted ? (
          <div className="text-center space-y-4">
            <div className="text-4xl">✉️</div>
            <p className="text-sm text-slate-700">
              입력한 이메일로 재설정 링크를 발송했습니다.<br />
              메일함을 확인해주세요. (스팸 폴더도 확인)
            </p>
            <Link to="/login" className="block mt-4 text-sm font-semibold text-[#2aa7aa] hover:underline">
              로그인으로 돌아가기
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">이메일</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="가입 시 등록한 이메일"
                required
                className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400"
              />
            </div>

            {error && <p className="text-sm text-red-500">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-xl bg-teal-500 py-2.5 text-sm font-semibold text-white hover:bg-teal-600 disabled:opacity-50 transition-colors"
            >
              {loading ? "전송 중..." : "재설정 링크 발송"}
            </button>

            <div className="flex items-center justify-between text-sm pt-1">
              <Link to="/login" className="text-slate-500 hover:underline">← 로그인</Link>
              <Link to="/find-username" className="text-[#2aa7aa] hover:underline">아이디 찾기</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
